/* eslint-disable consistent-return */
/* eslint-disable default-case */
import axios, { AxiosRequestConfig } from "axios";
import { toast } from "react-toastify";

import enviroment from "../enviroments";
import store from "../store";
import signOut from "./signOut";
import {
  checkAndRefreshTokenIfNeeded,
  getCurrentToken,
} from "../hooks/useRefreshToken";

let isRefreshingLogin = false;

const createAxiosInstance = () => {
  const config: AxiosRequestConfig = {
    baseURL: enviroment.BASE_URL,
    params: {
      cc: "b665ede5-2b53-4eec-99aa-143a6bc0cd7a",
    },
  };

  return axios.create(config);
};

const axiosInstance = createAxiosInstance();

/**
 * 1) Interceptor de Request
 *    - Injeta o Bearer <token> no cabeçalho se existir
 */
const requestSuccessHandler = (request: any) => {
  const { user } = store.getState();
  if (user?.token) {
    request.headers = { Authorization: `Bearer ${user.token}` };
  }
  return request;
};

const requestErrorHandler = (error: any) => {
  return Promise.reject(error);
};

/**
 * 2) Interceptor de Response (success e error)
 *    - success: retorna diretamente a response
 *    - error: trata timeout, status 500+, 401, 403, etc.
 */
const responseSuccessHandler = (response: any) => response;

const responseErrorHandler = async (error: any) => {
  if (!error.response) {
    if (error.message && error.message.match(/timeout/)) {
      toast.error(
        "⚠  Servidor demorou a responder (timeout). Tente novamente!"
      );
    } else {
      toast.error("⚠  Erro de conexão. Verifique sua rede e tente novamente.");
    }
    return Promise.reject(error);
  }

  const {
    response: { status: code },
  } = error;

  switch (true) {
    case code >= 500:
      toast.error("⚠  Servidor fora do ar, tente novamente mais tarde!");
      break;

    case code === 401:
      if (!isRefreshingLogin) {
        try {
          console.log("[axiosServicesLogin] Tentando refresh token após 401");
          isRefreshingLogin = true;

          const refreshSucceeded = await checkAndRefreshTokenIfNeeded();

          if (refreshSucceeded) {
            console.log(
              "[axiosServicesLogin] Refresh bem-sucedido, retentando request"
            );

            const newToken = getCurrentToken();
            if (!newToken) {
              throw new Error("Token não disponível após refresh");
            }

            const originalRequest = error.config;
            originalRequest.headers.Authorization = `Bearer ${newToken}`;

            return axios(originalRequest);
          }

          console.log("[axiosServicesLogin] Refresh falhou, fazendo logout");
          toast.error("Sua sessão expirou. Por favor, faça login novamente.");
          setTimeout(() => signOut(), 1000);
        } catch (refreshError) {
          console.error("[axiosServicesLogin] Erro no refresh:", refreshError);
          toast.error("Sua sessão expirou. Por favor, faça login novamente.");
          setTimeout(() => signOut(), 1000);
        } finally {
          isRefreshingLogin = false;
        }
      } else {
        console.log("[axiosServicesLogin] Refresh já em andamento");
      }
      break;

    case code === 403:
      toast.error("⚠ Acesso negado (403).");
      break;
    case code === 404:
      toast.error("⚠ Recurso não encontrado (404).");
      break;
    case code === 405:
      toast.error("⚠ Método não permitido (405).");
      break;
    // case code === 400:
    //   // Caso queira exibir algo específico...
    //   break;

    default:
      break;
  }

  return Promise.reject(error.response);
};

axiosInstance.interceptors.request.use(
  requestSuccessHandler,
  requestErrorHandler
);
axiosInstance.interceptors.response.use(
  responseSuccessHandler,
  responseErrorHandler
);

export default axiosInstance;
